import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
const IDEMPOTENT_METHODS = new Set(['POST', 'PUT', 'PATCH']);

import { AppService } from '../app.service';

@Injectable()
export class IdempotencyInterceptor implements HttpInterceptor {
    private readonly idempotencyService = inject(IdempotencyService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!IDEMPOTENT_METHODS.has(req.method)) return next.handle(req);

        const key = this.idempotencyService.get(req.url);
        const clonedRequest = req.clone({ setHeaders: { 'Idempotency-Key': key } });

        return next.handle(clonedRequest).pipe(tap(() => this.idempotencyService.reset(req.url)));
    }
}

@Injectable({
	providedIn: 'root',
})
export class IdempotencyService {
	private readonly appService = inject(AppService);

	private readonly _keys = new Map<string, string>();

	get(operation: string): string {
		if (!this._keys.has(operation)) this.set(operation);

		return this._keys.get(operation)!;
	}

	set(operation: string): void {
		this._keys.set(operation, this.appService.getObjectId());
	}

	reset(operation: string): void {
		this._keys.delete(operation);
	}
}
